import * as React from 'react'
import {
  FeaturedSectionContainer,
  FeaturedSectionImage,
  FeaturedSectionText
} from './FeaturedSection.elements'

type Props = {
  imageUrl: string,
  text: string
}

export const FeaturedSection: React.FunctionComponent<Props> = ({text, imageUrl}) => (
  <FeaturedSectionContainer >
    <FeaturedSectionText dangerouslySetInnerHTML={{__html: text}}/>
    <FeaturedSectionImage src={imageUrl} />
  </FeaturedSectionContainer>
)
